import React, { useState } from 'react';
import { Tabs } from 'antd';
import RoleInput from '../Organism/RoleInput';
import UserRoleInput from '../Organism/UserRoleInput';
import MassUploadUserRole from '../Organism/MassUploadUserRole';

const RolesPage: React.FC = () => {
  const [activeKey, setActiveKey] = useState('1');

  const onTabChange = (key: string) => {
    setActiveKey(key);
  };

  return (
    <Tabs activeKey={activeKey} onChange={onTabChange}>
      <Tabs.TabPane tab="Add Role" key="1">
        <RoleInput />
      </Tabs.TabPane>
      <Tabs.TabPane tab="Assign User Role" key="2">
        <UserRoleInput />
      </Tabs.TabPane>
      <Tabs.TabPane tab="Upload User Roles" key="3">
        <MassUploadUserRole />
      </Tabs.TabPane>
    </Tabs>
  );
};

export default RolesPage;